export const SET_HAS_KNOWLEDGE = 'SET_HAS_KNOWLEDGE';

export const SetHasKnowledge = (value) => {
    return {
        type: SET_HAS_KNOWLEDGE,
        payload: {
            value: value
        }
    }
}